import React, { Component } from 'react';
import { FaMale, FaFemale } from "react-icons/fa";
import './BodyIcon.css';

class BodyIcon extends Component {
    state = { width: 0, height: 0 ,N: -1};
    wIcon = 75; // pixel
    constructor(props){
        super(props);
        this.bodyIconContainer = React.createRef();
      }

      componentDidMount () {
        const resizeObserver = new ResizeObserver((event) => {
            if  (this.bodyIconContainer.current === null) 
                return;
            let width = this.bodyIconContainer.current.offsetWidth;
            let height = this.bodyIconContainer.current.offsetHeight;
            const N = Math.floor(width / this.wIcon);
            if (N !== this.state.N) {
                this.setState({ width: width, height: height,  N: N });
            }            
        });
        resizeObserver.observe(document.getElementById("BIC"));
      }

      render () {
        if(this.props.activePercent < 0){
            return <></>;
        }
        const icons = [];
        const N = this.state.N;
        const NActive = Math.max(Math.floor(N * this.props.activePercent / 100) , 1);
        const activeIndices = this.Randperm(N).slice(0, NActive); 
        for (let i = 0; i < N; i++) {
            let isActive = activeIndices.includes(i);
            let icon = this.GetIcon(i, isActive);
            icons.push(
                <li key={i} className="body-icon-item">
                    {icon}
                </li>);
        }
        return (
            <div id = "BIC" className='pt-4 body-icon-container' ref = {this.bodyIconContainer}>
                <ul className='inlineList'>{icons}</ul>
            </div>
        )
      }

      GetIcon (index, isActive) { 
        let activeClass = isActive ? 'icon-active' : 'icon-inactive';
          if(index%2===0)
              return <FaMale className = {activeClass} />
          else
              return <FaFemale className = {activeClass} />
      };


      Randperm(length) { 
        let perm = Array.from({ length }, (_, i) => i);
        for (let i = perm.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = perm[i];
        perm[i] = perm[j];
        perm[j] = temp;
        }
        return perm;
    }     
}

export default BodyIcon;